import {
  DateRangePreset,
  dateRangePresetsToTitlesMap,
} from '../../constants/dateRangePreset';

export const getTitleForPreset = (preset: DateRangePreset, prefix?: string): string => {
  const title = dateRangePresetsToTitlesMap[preset] ?? preset;

  return prefix ? `${prefix} ${title}` : title;
};
